import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';

const ContentWithContext = (props) => {
  const {
    loadPageContentLink,
    setPageContentCollection,
    refreshPageContentCollection,
  } = usePageContentContext();

  return (
    <Content
      {...props}
      loadLink={loadPageContentLink}
      setCollection={setPageContentCollection}
      refreshCollection={refreshPageContentCollection}
    />
  );
};

export default ContentWithContext;
